<template>
  <div class="wechat-required">
    <van-icon name="wechat" size="64" color="#07c160" />
    <div class="title">请在微信客户端打开</div>
    <div class="message">该功能需要验证微信身份，请返回上一页，复制原页面链接并在微信中打开。</div>
    <div class="actions">
      <van-button icon="arrow-left" round block @click="goBack">返回上一页</van-button>
      <van-button v-if="$route.query.reason === 'error'" type="primary" round block @click="reload">重新尝试</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WechatRequired',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
        return
      }

      const redirect = this.$route.query.redirect
      const resolved = redirect ? this.$router.resolve(redirect) : null
      const miceLink = resolved && resolved.route && resolved.route.params.miceLink
      this.$router.replace(miceLink ? `/index/${miceLink}` : '/')
    },
    reload() {
      const redirect = this.$route.query.redirect
      if (redirect) {
        window.location.replace(redirect)
      } else {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped lang="less">
.wechat-required {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 120px 32px 40px;
  text-align: center;
  background: #f7f8fa;
}
.title {
  margin-top: 20px;
  color: #222;
  font-size: 20px;
  font-weight: 600;
}
.message {
  margin: 14px auto 30px;
  max-width: 320px;
  color: #666;
  font-size: 14px;
  line-height: 1.8;
}
.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 240px;
  margin: 0 auto;
}
</style>
